import React, { useState, useEffect } from "react";

import ProgressCircle from "../component/progresscircle";


function Salary() {

  const [activeModal, setActiveModal] = useState(null);
  const [salaryList, setSalaryList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [salaryStatusMap, setSalaryStatusMap] = useState("unpaid");

  // Dummy Employees
  const employees = [
    { id: 1, name: "Rahul Sharma", basic: 30000 },
    { id: 2, name: "Amit Kumar", basic: 28000 },
    { id: 3, name: "Sneha Gupta", basic: 32000 },
    { id: 4, name: "Rohit Verma", basic: 25000 },
  ];

  // Load Dummy Salary Data
  useEffect(() => {
    const dummy = employees.map((emp) => {

      const absent = Math.floor(Math.random() * 3);
      const leave = Math.floor(Math.random() * 2);

      const pf = 1800;
      const gross = emp.basic - pf;
      const oneday = emp.basic / 30;
      const paidAmount = emp.basic - pf - oneday * absent;

      return {
        id: emp.id,
        name: emp.name,
        basic: emp.basic,
        pf,
        gross,
        absent,
        leave,
        paidAmount: paidAmount.toFixed(0),
        period: "2026-03",
        salarycheck: false,
        statuscheck: "unpaid"
      };
    });

    setSalaryList(dummy);

  }, []);

  function salarystatus(value) {
    setSalaryStatusMap(value);
  }

  function salaryAdd(id) {

    const updated = salaryList.map((row) =>
      row.id === id
        ? { ...row, salarycheck: true, statuscheck: salaryStatusMap }
        : row
    );

    setSalaryList(updated);
  }

  const handleEdit = (salary) => {
    setEditId(salary.id);
    setEditForm({
      paidAmount: salary.paidAmount,
      period: salary.period,
      status: salary.statuscheck
    });
  };

  const handleCancel = () => {
    setEditId(null);
    setEditForm({});
  };

  const handleSave = (id) => {

    const updated = salaryList.map((s) =>
      s.id === id
        ? { ...s, statuscheck: editForm.status }
        : s
    );

    setSalaryList(updated);
    setEditId(null);
    setEditForm({});
  };

  const handleDelete = (id) => {

    const updated = salaryList.map((s) =>
      s.id === id
        ? { ...s, salarycheck: false, statuscheck: "unpaid" }
        : s
    );

    setSalaryList(updated);
  };

  return (
    <>
      <div className="page-header-tap">
        <h3>Salary</h3>

        <div>

          <select className="select">
            <option>Export Excel</option>
            <option>Download PDF</option>
          </select>

          <button
            onClick={() => setActiveModal("addsalary")}
            className="addbtn"
          >
            + Add Salary
          </button>

          {/* <ModalForms
            activeModal={activeModal}
            openModal={setActiveModal}
            closeModal={() => setActiveModal(null)}
          /> */}

        </div>
      </div>

      <div className="counter-boxed-div">

        <ProgressCircle complete={4} full={10} label="Total Employee" />
        <ProgressCircle complete={2} full={10} label="Total Paid" />
        <ProgressCircle complete={2} full={10} label="Total Unpaid" />
        <ProgressCircle complete={1} full={10} label="Today Leave" />

      </div>

      <div className="table-div" style={{ marginTop: "20px" }}>

        <div className="table-header">

          <h5>Salary list</h5>

          <div>

            <select className="filterselect">
              <option>Jan</option>
              <option>Feb</option>
              <option>Mar</option>
              <option>Apr</option>
            </select>

          </div>

        </div>

        <div className="table">

          <table>

            <thead>

              <tr>
                <th>Emp Id</th>
                <th>Emp Name</th>
                <th>Basic</th>
                <th>PF</th>
                <th>Gross</th>
                <th>Absent</th>
                <th>Leave</th>
                <th>Paid Amount</th>
                <th>Date</th>
                   <th>Screenshot</th>
                <th>Status</th>
             
                <th>Action</th>
              </tr>

            </thead>

            <tbody>

              {salaryList.map((row) => (

                <tr key={row.id}>

                  <td>{row.id}</td>
                  <td>{row.name}</td>
                  <td>{row.basic}</td>
                  <td>{row.pf}</td>
                  <td>{row.gross}</td>
                  <td>{row.absent}</td>
                  <td>{row.leave}</td>
                  <td>₹ {row.paidAmount}</td>
                  <td>{row.period}</td>
<td>photo</td>
                  <td>

                    {editId === row.id ? (

                      <select
                        value={editForm.status}
                        onChange={(e) =>
                          setEditForm({ ...editForm, status: e.target.value })
                        }
                      >
                        <option value="unpaid">Unpaid</option>
                        <option value="paid">Paid</option>
                      </select>

                    ) : row.salarycheck ? (

                      <span className="statusbox green-bg">
                        {row.statuscheck}
                      </span>

                    ) : (

                      <select
                        onChange={(e) => salarystatus(e.target.value)}
                      >
                        <option value="unpaid">Unpaid</option>
                        <option value="paid">Paid</option>
                      </select>

                    )}

                  </td>

                  <td style={{ textAlign: "end" }}>

                    {row.salarycheck ? (

                      editId === row.id ? (

                        <>
                          <button
                            onClick={() => handleSave(row.id)}
                            className="statusbox green-bg"
                          >
                            Save
                          </button>

                          <button
                            onClick={handleCancel}
                            className="statusbox red-bg"
                          >
                            Cancel
                          </button>
                        </>

                      ) : (

                        <>
                          <button
                            onClick={() => handleEdit(row)}
                            className="statusbox green-bg"
                          >
                            ✏️
                          </button>

                          <button
                            onClick={() => handleDelete(row.id)}
                            className="statusbox red-bg"
                          >
                            ✖
                          </button>
                        </>

                      )

                    ) : (

                      <button
                        className="statusbox green-bg"
                        onClick={() => salaryAdd(row.id)}
                      >
                        Add
                      </button>

                    )}

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>
    </>
  );
}

export default Salary;